export function formatPercent(percent, withSymbol = true) {
  let formatted = percent.toFixed(2);

  // Use an en dash for negatives. This is a slightly longer dash than a hyphen.
  if (formatted[0] === "-") {
    formatted = "–" + formatted.slice(1);
  }

  // Chop zeroes off the end.
  while (formatted[formatted.length - 1] === "0") {
    formatted = formatted.slice(0, formatted.length - 1);
  }

  // Chop off decimal point if no fractional component remains.
  if (formatted[formatted.length - 1] === ".") {
    formatted = formatted.slice(0, formatted.length - 1);
  }

  if (withSymbol) {
    formatted += "%";
  }

  return formatted;
}
